import { jsx as _jsx } from "react/jsx-runtime";
// 表格カード。自身が有界の縦スクロール容器（overflow-auto + max-h）になり、
// 中の thead が sticky top-0 で「表格内の最上部」に凍結する。
// これによりヘッダーはページ全体に浮かず、表格領域の中だけで固定される。
// 横に広い表格はこの容器内で横スクロールする。
export const DataTable = ({ children, className = '' }) => (_jsx("div", { className: `bg-white shadow rounded-lg overflow-auto max-h-[70vh] ${className}`, children: _jsx("table", { className: "min-w-full divide-y divide-gray-200", children: children }) }));
// sticky thead。スクロール容器（DataTable もしくは overflow-auto を持つ表格ラッパー）の
// 最上部に top-0 で凍結する。
export const DataTableHead = ({ children, className = '' }) => (_jsx("thead", { className: `bg-gray-50 sticky top-0 z-10 ${className}`, children: children }));
export default DataTable;
